import { render } from "./ClassesStudentssettled.vue?vue&type=template&id=37702114&scoped=true"
import script from "./ClassesStudentssettled.vue?vue&type=script&lang=js"
export * from "./ClassesStudentssettled.vue?vue&type=script&lang=js"

import "./ClassesStudentssettled.vue?vue&type=style&index=0&id=37702114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37702114"]])

export default __exports__